export type LabelPrinterKind = 'browser' | 'dymo'

export type PrintEntryLabelPayload = {
  entryCode: string
  classCode?: string | null
  showName?: string | null
}

export type LabelPrinterDevice = {
  id: string
  name: string
  model?: string
}

export type LabelPrintOptions = {
  printer?: LabelPrinterDevice
  copies?: number
  jobKey?: string
}

export interface LabelPrinterStrategy {
  kind: LabelPrinterKind
  label: string
  listPrinters(): Promise<LabelPrinterDevice[]>
  printEntryLabel(payload: PrintEntryLabelPayload, options?: LabelPrintOptions): Promise<void>
}

export type LabelPrinterErrorOptions = {
  cause?: unknown
  helpUrl?: string | null
  helpLabel?: string | null
}

function isLabelPrinterErrorOptions(input: unknown): input is LabelPrinterErrorOptions {
  if (!input || typeof input !== 'object') return false
  const candidate = input as Record<string, unknown>
  return (
    Object.prototype.hasOwnProperty.call(candidate, 'cause') ||
    Object.prototype.hasOwnProperty.call(candidate, 'helpUrl') ||
    Object.prototype.hasOwnProperty.call(candidate, 'helpLabel')
  )
}

export class LabelPrinterError extends Error {
  public readonly cause?: unknown
  public readonly helpUrl: string | null
  public readonly helpLabel: string | null

  constructor(message: string, causeOrOptions?: unknown) {
    super(message)
    this.name = 'LabelPrinterError'
    const options: LabelPrinterErrorOptions = isLabelPrinterErrorOptions(causeOrOptions)
      ? causeOrOptions
      : { cause: causeOrOptions }
    this.cause = options.cause
    this.helpUrl = options.helpUrl ?? null
    this.helpLabel = options.helpLabel ?? null
  }
}

export type LabelTemplateFields = {
  entryCode: string
  classCode?: string | null
  showName?: string | null
}
